// extracted by mini-css-extract-plugin
module.exports = {"dialogTitle":"PuiDialog_dialogTitle__2N1wr"};